module.exports = "//public.zight.com/packs/media/images/icons-magic-c821a5531927debc69436afd86e52dce.svg";